import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefault = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "64px",
	height: "64px",
	viewBox: "-81.92 -81.92 675.84 675.84",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"aria-hidden": "true",
	role: "img",
	className: "iconify iconify--fxemoji",
	preserveAspectRatio: "xMidYMid meet",
	fill: "#000000",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_bgCarrier",
			strokeWidth: 0,
			children: /* @__PURE__ */ _jsx("rect", {
				x: -81.92,
				y: -81.92,
				width: 675.84,
				height: 675.84,
				rx: 0,
				fill: "#ffffff",
				strokeWidth: 0
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_tracerCarrier",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "SVGRepo_iconCarrier",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#C2CCCE",
					d: "M505.999 104.494a23.067 23.067 0 0 0-19.614-19.615l-.329-.329H22.572l-.327.329A23.067 23.067 0 0 0 2.63 104.494l-.328.327v298.987l.328.329a23.067 23.067 0 0 0 19.615 19.615l.327.327h463.483l.329-.329a23.062 23.062 0 0 0 19.614-19.614l.329-.329V104.821l-.328-.327z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#597B91",
					d: "M2.302 149.609h504.024V236H2.302z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFF",
					d: "M442.478 294.697H69.522c-23.116 0-41.855 18.739-41.855 41.854c0 23.116 18.739 41.855 41.855 41.855h372.957c23.116 0 41.855-18.739 41.855-41.855c-.001-23.115-18.74-41.854-41.856-41.854z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#597B91",
					d: "M348.576 371.698c-1.13 0-2.238-.024-3.326-.072c-13.51-.604-22.237-4.798-27.875-9.934c-19.207 9.371-42.187 13.168-51.84 4.363c-3.646-3.324-8.474-10.958.139-24.728c6.98-11.159 8.596-20.652 4.021-23.623c-5.534-3.594-19.407-.151-28.546 13.417c-7.215 10.713-20.291 21.218-34.977 28.101c-7.572 3.549-26.516 11.043-38.877 4.004c-6.398-3.643-15.306-13.61-3.072-39.438c1.489-3.144 1.483-4.788 1.364-5.117c-2.353-2.743-22.062-1.928-42.894 9.78c-13.271 7.458-20.56 16.171-18.57 22.195a7.501 7.501 0 0 1-14.244 4.705c-4.067-12.314 2.827-25.195 19.411-36.271c18.365-12.266 52.469-23.503 66.095-11.737c3.506 3.026 8.478 10.021 2.394 22.866c-4.848 10.233-6.078 18.263-3.062 19.979c8.7 4.959 40.956-8.093 53.991-27.447c6.122-9.09 14.594-15.913 23.857-19.215c9.37-3.34 18.591-2.759 25.3 1.596c9.678 6.284 14.898 21.184.527 44.159c-2.144 3.428-2.468 5.253-2.509 5.876c3.303 2.229 18.115.825 33.107-6.037c-2.906-8.005-2.909-17.684.06-27.01c3.132-9.841 8.966-17.644 15.605-20.872c10.473-5.092 18.629 1.841 22.433 9.324c7.173 14.11 1.809 29.42-14.717 42.004c-.323.247-.65.492-.981.735c20.276 10.854 64.889-6.649 84.099-15.161a7.5 7.5 0 0 1 6.077 13.715c-29.741 13.177-54.27 19.843-72.99 19.843zm-16.932-57.141c-1.332.248-5.402 3.743-8.013 11.238c-1.632 4.685-2.439 10.385-1.314 15.562c.363-.267.723-.536 1.081-.811c7.26-5.556 14.942-14.089 10.318-23.186c-1.031-2.028-1.84-2.655-2.072-2.803z"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
